import axios from "axios";
import AssignOTService from "../service/OTService";

export const fetchOTtimes = () => async dispatch => {
  dispatch({ type: "FETCH_TIMES_REQUEST" });
  try {
    const response = await axios.get(
     //`https://esystems.cdl.lk/backend-test/AttendMe2/AttmeBiz/GetTimeSlot2 `
     `AttmeBiz/GetTimeSlot2`
    );
    
    //const resultSet = response.data.ResultSet;
    //console.log("resultSet");

    dispatch({type: "FETCH_TIMES_SUCCESS", payload: response.data.ResultSet});
  } catch (error) {
    console.error("Error fetching timeslots data", error);
    dispatch({ type: "FETCH_TIMES_FAILURE" });
  }
};

export const fetchOTjobAttendance = (date, company, location1,jobIwno) => async dispatch => {
  dispatch({ type: "FETCH_OT_JOB_ATTENDANCE_REQUEST" });
  try {    
    const response = await AssignOTService.getEmpJob(date, jobIwno, location1,company);

    const { AttendancList } = response.data;
    dispatch({
      type: "FETCH_OT_JOB_ATTENDANCE_SUCCESS",
      payload: AttendancList || [], // Ensure it defaults to an empty array if no data.
    });

    //dispatch({ type: "FETCH_OT_JOB_ATTENDANCE_SUCCESS", payload: response.data.AttendancList || [] });
    
  } catch (error) {
    console.error("Error fetching ot job attendance data:", error);
    dispatch({ type: "FETCH_OT_JOB_ATTENDANCE_FAILURE" });
  }
};

// export const fetchOTjobAttendance = (date,company,location1,iwNo) => async (dispatch) => {
//     dispatch({ type: "FETCH_OT_JOB_ATTENDANCE_REQUEST" });

//     try {

//       const parameters = {
//         date,
//         company,
//         location1,
//         iwNo,
//       };

//       const response = await axios.post(
//         `http://172.30.30.96:2500/attme/GetEmpJobDetails?date=2025-1-2&iwNo=${iwNo}`,
//         parameters,
//         {
//           headers: {
//             userid: "DTSUSER",
//             password: "Dts@10099",
//           },
//         }
//       );
//       dispatch({ type: "FETCH_OT_JOB_ATTENDANCE_SUCCESS", payload: response.data });
//     } catch (error) {
//       dispatch({ type: "FETCH_OT_JOB_ATTENDANCE_FAILURE", error: error.message });
//     }
//   };

////////////////////////////



export const fetchOTdetails = (date) => async dispatch => {
  dispatch({ type: "FETCH_OT_DETAILS_ATTENDANCE_REQUEST" });
  try {    
    const response = await AssignOTService.getEmpOT(date);
    dispatch({ type: "FETCH_OT_DETAILS_ATTENDANCE_SUCCESS", payload: response.data.AttendancList });
    //console.log(response.data.AttendancList);
  } catch (error) {
    console.error("Error fetching ot job attendance data:", error);
    dispatch({ type: "FETCH_OT_DETAILS_ATTENDANCE_FAILURE" });
  }
};



export const assignOT = (postData) => async (dispatch) => {
  dispatch({ type: "ASSIGN_OT_REQUEST" });
  try {
    const response = await AssignOTService.postAssignOt(postData);
    dispatch({ type: "ASSIGN_OT_SUCCESS", payload: response.data });
  } catch (error) {
    dispatch({ type: "ASSIGN_OT_FAILURE", error: error.message });
  }
};

export const fetchSundayData = (location) => async dispatch => {
  dispatch({ type: "FETCH_SUNDAY_DATA_REQUEST" });
  try {    
    const response = await AssignOTService.getJobVice(location);
    const AttendancList  = response.data.JobsList;
    dispatch({
      type: "FETCH_SUNDAY_DATA_SUCCESS",
      payload: AttendancList || []  });    //,  payload: response.data.JobsList
    
  } catch (error) {
    console.error("Error fetching ot job attendance data:", error);
    dispatch({ type: "FETCH_SUNDAY_DATA_FAILURE" });
  }
};


export const fetchHolidays = () => async dispatch => {
  dispatch({ type: "FETCH_HOLIDAYS_REQUEST" });
  try {
    const response = await AssignOTService.getCDLHolidy();
    dispatch({ type: "FETCH_HOLIDAYS_SUCCESS", payload: response.data.HolidayList });
  } catch (error) {
    console.error("Error fetching holidays data:", error);
    dispatch({ type: "FETCH_HOLIDAYS_FAILURE" });
  }
};







// export const assignOT = (postData) => async (dispatch) => {
//   dispatch({ type: "ASSIGN_OT_REQUEST" });
//   try {
//     const response = await axios.post(
//       `http://172.30.30.96:2500/attme/AssignOt`,
//       postData,
//       {
//         headers: {
//           userid: "DTSUSER",
//           password: "Dts@10099",
//         },
//       }
//     );
//     dispatch({ type: "ASSIGN_OT_SUCCESS", payload: response.data });
//   } catch (error) {
//     dispatch({ type: "ASSIGN_OT_FAILURE", error: error.message });
//   }
// };




// export const fetchSundayData = (location) => async (dispatch) => {
//   dispatch({ type: "FETCH_SUNDAY_DATA_REQUEST" });
//   try {
//     const response = await axios.get(
//       `http://172.30.30.96:2500/attme/GetJobViceEmp?Location=${location}`,
//       {
//         headers: {
//           userid: "DTSUSER",
//           password: "Dts@10099",
//         },
//       }
//     );
    
//     if (response.data && response.data.responceType === true) {
//       dispatch({
//         type: "FETCH_SUNDAY_DATA_SUCCESS",
//         payload: response.data.JobsList,
//       });
//     } else {
//       throw new Error(response.data.responceMessage || "Invalid response from server");
//     }
//   } catch (error) {
//     console.error("Error fetching Sunday data:", error.response ? error.response.data : error.message);
//     dispatch({
//       type: "FETCH_SUNDAY_DATA_FAILURE",
//       payload: error.response ? error.response.data : error.message,
//     });
//   }
// };

